import { render } from "./queryMe.vue?vue&type=template&id=5a3a3e77"
import script from "./queryMe.vue?vue&type=script&lang=js"
export * from "./queryMe.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__